import { getAgentVersionReport } from '@api/portalServices';
import { useMutation } from '@tanstack/react-query';

export const useAgentVersionReport = () => {
  return useMutation<Blob>({
    mutationFn: async () => {
      return getAgentVersionReport();
    },
  });
};
